import { round3 } from './pricing';

/**
 * Cap the requested wallet usage by:
 *  - the user's current wallet balance,
 *  - the maximum payable amount (subtotal TTC + delivery fee),
 *  - non-negativity.
 *
 * Returns 0 if any of the inputs are invalid.
 */
export function clampWalletUse(
  requested: number,
  balance: number,
  capPayable: number,
): number {
  if (!isFinite(requested) || requested <= 0) return 0;
  if (!isFinite(balance) || balance <= 0) return 0;
  if (!isFinite(capPayable) || capPayable <= 0) return 0;
  return round3(Math.min(requested, balance, capPayable));
}

/**
 * Project the final amount the user has to pay after wallet deduction.
 */
export function computeAmountToPay(
  subtotalTtc: number,
  deliveryFee: number,
  walletUsed: number,
): number {
  return round3(Math.max(0, subtotalTtc + deliveryFee - walletUsed));
}

export function projectWalletAfterOrder(
  currentBalance: number,
  commissionEarnedPending: number,
  walletUsed: number,
): { available: number; pendingCommission: number } {
  return {
    available: round3(currentBalance - walletUsed),
    pendingCommission: round3(commissionEarnedPending),
  };
}
